import './index.scss'
import Pius from '../../assets/images/transparent1.png'
import PiusWebP from '../../assets/images/webp/transparent1.webp'
import OptimizedImage from '../OptimizedImage'
import BackgroundWaves from '../BackgroundWaves'
import { Trans, useTranslation } from 'react-i18next';

/**
 * About page with a short bio and a portrait.
 */
const About = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className='about' id='about'>
                <BackgroundWaves />
                <div className='background1' />
                <div className='about-content'>
                    <h2>
                        <Trans i18nKey='about' components={{ 1: <span /> }} />
                    </h2>

                    <h3>
                        <Trans i18nKey='media' components={[<br key="0" />, <span className="surname" key="1" />]} />
                    </h3>
                    <p>{t('text_about_1')}</p>
                    <p>{t('text_about_2')}</p>
                    <p>{t('text_about_3')}</p>
                </div>
                <div className='about-img'>
                    <OptimizedImage 
                        src={Pius} 
                        webpSrc={PiusWebP}
                        alt={t('about_img_alt')}
                        loading="lazy"
                    />
                </div>
            </div>

        </>
    );

}

export default About;
